export default () => {
  return {
    id: null,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    ext: '',
    title: '',
    disabled: null,
    resetFlag: null,
    role: '',
    created_at: null,
    updated_at: null,
    photo: null,
    customer_id: null,
    customer_name: '',
    abilities: [],
    justLoggedIn: false
  }
}
